import { useCallback, useEffect, useRef, useState } from "react";
import { SHIFT_PRODUCTION_FORM_API_BASE, shiftFormApprovalScheduleSettingsResponseSchema, type ShiftFormApprovalScheduleSettings } from "../../../shared/shift-production-form/contracts";
import { apiRequest } from "../../shared/api/client";

const endpoint = `${SHIFT_PRODUCTION_FORM_API_BASE}/admin/approval-schedule`;

export function useApprovalMailSchedule() {
  const [settings, setSettings] = useState<ShiftFormApprovalScheduleSettings | null>(null);
  const [phase, setPhase] = useState<"loading" | "ready" | "saving" | "error">("loading");
  const [message, setMessage] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const generation = useRef(0);
  const saving = useRef(false);
  const load = useCallback(async () => {
    const request = ++generation.current;
    setPhase("loading"); setMessage(null); setSaved(false);
    try {
      const result = shiftFormApprovalScheduleSettingsResponseSchema.parse(await apiRequest<unknown>(endpoint, { cache: "no-store" }));
      if (request === generation.current) { setSettings(result.settings); setPhase("ready"); }
    } catch {
      if (request === generation.current) { setSettings(null); setPhase("error"); setMessage("Gönderim saati alınamadı. Yeniden deneyin."); }
    }
  }, []);
  useEffect(() => { void load(); return () => { generation.current += 1; }; }, [load]);
  const save = async (sendTime: string, expectedVersion: number) => {
    if (saving.current) return;
    saving.current = true;
    const request = ++generation.current;
    setPhase("saving"); setMessage(null); setSaved(false);
    try {
      const result = shiftFormApprovalScheduleSettingsResponseSchema.parse(await apiRequest<unknown>(endpoint, { method: "PATCH", body: JSON.stringify({ sendTime, expectedVersion }) }));
      if (request === generation.current) { setSettings(result.settings); setPhase("ready"); setSaved(true); }
    } catch {
      if (request === generation.current) { setPhase("ready"); setMessage("Saat kaydedilemedi. Başka bir yönetici değiştirmiş olabilir; güncel saati yükleyip tekrar deneyin."); }
    } finally {
      saving.current = false;
    }
  };
  return { settings, phase, message, saved, load, save };
}
